import { useEffect, useState } from 'react'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import { Grid, TextareaAutosize } from '@mui/material'
import ParentInfoForm from '@Components/ParentInfoForm/ParentInfoForm'
import StudentInfoForm from '@Components/StudentInfoForm/StudentInfoForm'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import EducatorInfoActions from '@EducatorActions/educator-info.action'
import UploadFiles from '@Components/UploadFile/UploadFiles'
import { CommonService } from '@Services/common.service'
import RegroundAction from '@ClientActions/reground.action'
import { EducatorActionTypes } from '@EducatorStores/educator.action-types'
import { ICommonQuery } from '@Models/common.model'

interface IEducatorInfoProps {
    createForm?: any
    updatedForm?: any
    getEducators?: any
    educators?: any[]
    getStudentCities?: any
    getDynamicParentCity?: (index?: number, params?: ICommonQuery) => void
    firstBoxTitle?: string
    secondFirstTitle?: string
    addMoreBtnLabel?: string
    pageType?: string
}
function EducatorInfo(props: IEducatorInfoProps) {
    const {
        createForm,
        updatedForm,
        getEducators,
        educators,
        getStudentCities,
        getDynamicParentCity,
        firstBoxTitle = 'STUDENT INFORMATION',
        secondFirstTitle = 'PARENT | GUARDIAN',
        addMoreBtnLabel = 'Add Parent | Guardian',
        pageType = 'EDUCATIONAL',
    } = props

    const defaultValues = {
        id: '',
        firstName: '',
        middleName: '',
        lastName: '',
        ssnNum: '',
        schoolId: '',
        address: '',
        state: '',
        city: '',
        zipCode: '',
        dob: null,
        profileImage: '',
        profileImageId: '',
        loading: false,
        reason: '',
        fileId: '',
        fileUrl: '',
        fileName: '',
        parents: [
            {
                id: '',
                firstName: '',
                middleName: '',
                lastName: '',
                contactNumber: '',
                relationship: '',
                address: '',
                state: '',
                city: '',
                zipCode: '',
                profileImage: '',
                loading: false,
            },
        ],
    }

    const [detailEducator, setDetailEducator] = useState<any>({})
    const [tempFile, setTempFile] = useState<any>({})
    const [fileUploadLoading, setfileUploadLoading] = useState(false)
    const ac = new AbortController()
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch,
    } = useForm({ defaultValues })
    const parentArray = useFieldArray({
        control,
        name: 'parents',
    })

    const handleFileChange = (file: any) => {
        setfileUploadLoading(true)
        CommonService.uploadFile(file)
            .then((response: any) => {
                setfileUploadLoading(false)
                const newFile = {
                    ...file,
                    fileUrl: response?.url,
                }
                setTempFile(newFile)
                setValue('fileId', response?.id)
            })
            .catch((uploadError) => {
                setTempFile({})
                setfileUploadLoading(false)
                // console.log(uploadError)
            })
    }

    const handleRemoveFileUpload = () => {
        setTempFile({})
        setValue('fileId', '')
    }

    const onSubmit = (data: any) => {
        const parents = data?.parents?.map((item: any, index: number) => {
            return {
                id: item?.id || '',
                firstName: item?.firstName,
                middleName: item?.middleName || '',
                lastName: item?.lastName || '',
                type: pageType,
                relationship: item?.relationship || '',
                address: item?.address || '',
                state: item?.state || '',
                city: item?.city || '',
                zip: item?.zipCode || '',
                imageId: item?.profileImage?.fileId || '',
                phone: item?.contactNumber || '',
                sequence: index,
            }
        })

        const body: any = {
            parents,
            id: data?.id || '',
            firstName: data?.firstName,
            middleName: data?.middleName,
            lastName: data?.lastName,
            dob: data?.dob ? data?.dob?.toISOString() : '',
            schoolId: data?.schoolId,
            ssnId: data?.ssnNum,
            type: pageType,
            address: data?.address,
            state: data?.state,
            city: data?.city,
            zip: data?.zipCode,
            imageId: data?.profileImageId,
            reason: data?.reason,
            files: [
                {
                    fileId: data?.fileId || '',
                    type: 'FILE',
                    sequence: 1,
                },
            ],
        }

        if (!data?.fileId) delete body?.files
        // if (educators?.length) {
        //     const newData = body?.parents.map((item: any) => {
        //         // eslint-disable-next-line no-param-reassign
        //         if (!item?.id) delete item?.id
        //         return item
        //     })
        //     const newBody = { ...body, ...newData }

        //     updatedForm(body?.id, newBody)
        // } else {
        delete body?.id
        const newData = body?.parents.map((item: any) => {
            // eslint-disable-next-line no-param-reassign
            delete item?.id
            return item
        })

        const newBody = { ...body, ...newData }
        createForm(newBody)
        // }
    }

    useEffect(() => {
        const params = {
            type: pageType,
        }
        // getEducators(params)
    }, [])

    // useEffect(() => {
    //     if (!educators?.length) return
    //     if (educators?.length) {
    //         const educator = educators[0]
    //         setDetailEducator(educator)
    //         const parents = educator?.parents?.map(
    //             (item: any, index: string) => {
    //                 return {
    //                     id: item?.id || '',
    //                     firstName: item?.firstName || '',
    //                     middleName: item?.middleName || '',
    //                     lastName: item?.lastName || '',
    //                     contactNumber: item?.phone || '',
    //                     relationship: item?.relationship || '',
    //                     address: item?.address || '',
    //                     state: item?.state?.code || '',
    //                     city: item?.city?.code || '',
    //                     zipCode: item?.zip || '',
    //                     profileImage: {
    //                         fileId: item?.imageId,
    //                         sequence: index,
    //                         fileUrl: item?.imageUrl,
    //                     },
    //                     loading: false,
    //                 }
    //             }
    //         )

    //         const newValue = {
    //             id: educator?.id,
    //             firstName: educator?.firstName || '',
    //             middleName: educator?.middleName || '',
    //             lastName: educator?.lastName || '',
    //             ssnNum: educator?.ssnId || '',
    //             schoolId: educator?.schoolId || '',
    //             address: educator?.address || '',
    //             state: educator?.state?.code || '',
    //             city: educator?.city?.code || '',
    //             zipCode: educator?.zip || '',
    //             dob: (new Date(educator?.dob) as any) || null,
    //             profileImage: educator?.imageUrl || '',
    //             profileImageId: educator?.imageId || '',
    //             loading: false,
    //             reason: educator?.reason || '',
    //             fileId: educator?.files?.length
    //                 ? educator?.files[0]?.fileId
    //                 : '',
    //             parents,
    //         }

    //         if (educator?.files?.length) {
    //             const eduFile: any = {
    //                 fileId: educator?.files[0]?.fileId,
    //                 fileUrl: educator?.files[0]?.fileUrl,
    //                 filename: educator?.files[0]?.originalName,
    //             }
    //             setTempFile(eduFile)
    //         }

    //         getStudentCities({ parentCode: educator?.state?.code })

    //         // get parent city
    //         // eslint-disable-next-line no-unused-expressions
    //         educator?.parents?.length
    //             ? educator?.parents?.forEach((item: any, index: number) => {
    //                   if (item?.state?.code) {
    //                       if (getDynamicParentCity)
    //                           getDynamicParentCity(index, {
    //                               parentCode: item?.state?.code,
    //                           })
    //                   }
    //               })
    //             : ''

    //         reset(newValue)
    //     }
    // }, [educators])

    useEffect(() => {
        return () => {
            ac.abort()
        }
    }, [])

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="page-white-card p-4 mb-2">
                <StudentInfoForm
                    control={control}
                    errors={errors}
                    watch={watch}
                    reset={reset}
                    setValue={setValue}
                    defaultValue={defaultValues}
                    detail={detailEducator}
                    title={firstBoxTitle}
                />
            </div>
            <div className="page-white-card p-4 mb-2">
                <ParentInfoForm
                    control={control}
                    errors={errors}
                    watch={watch}
                    reset={reset}
                    setValue={setValue}
                    parentArray={parentArray}
                    detail={detailEducator}
                    title={secondFirstTitle}
                    addBtnTitle={addMoreBtnLabel}
                />
            </div>
            <div className="page-white-card p-4">
                <Grid container spacing={2}>
                    <Grid item sm={6}>
                        <Controller
                            control={control}
                            name="reason"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <span>
                                    <TextareaAutosize
                                        ref={ref}
                                        value={value}
                                        onChange={onChange}
                                        className="text-area"
                                        placeholder="Reason for Submition"
                                    />
                                </span>
                            )}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <UploadFiles
                            style={{ height: '170px' }}
                            remove
                            fileChanged={handleFileChange}
                            isLoading={fileUploadLoading}
                            filename={tempFile?.filename}
                            fileUrl={tempFile?.fileUrl}
                            removeAction={handleRemoveFileUpload}
                            label="upload paperwork"
                        />
                    </Grid>
                </Grid>
            </div>
            <div className="text-right mt-2">
                <button
                    type="submit"
                    className="educator-primary-btn"
                    style={{ marginRight: '25px' }}
                >
                    Submit
                </button>
            </div>
        </form>
    )
}

const mapStateToProps = (store: any) => {
    const { educators } = store?.educator?.educatorInfo
    return {
        educators,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getDynamicCity } = EducatorInfoActions
    return {
        createForm: (body: any) =>
            dispatch(EducatorInfoActions.createEducatorInfo(body) as any),
        // getDynamicCity: (index: number) =>
        //     dispatch(getDynamicCity(index) as any),
        getEducators: (params: any) =>
            dispatch(EducatorInfoActions.getEducatorInfo(params) as any),
        updatedForm: (id: string, body: any) =>
            dispatch(EducatorInfoActions.updateEducatorInfo(id, body) as any),
        getStudentCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    EducatorActionTypes.GET_STUDENT_CITIES,
                    params
                ) as any
            ),
        getDynamicParentCity: (index?: number, params?: ICommonQuery) =>
            dispatch(getDynamicCity(index, params) as any),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EducatorInfo)
